module.exports = __webpack_public_path__ + "img/sen_deform.6f7907bc.png";